// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import updateAwaitingSearchFields from "@guestsupply/App/Handlers/OrderApprovalList/UpdateAwaitingSearchFields";
import { CustomAppState } from "@guestsupply/App/Store/Reducers";
import { getOrderAwaitingApprovalsDataView } from "@guestsupply/App/Store/Selectors/OrderApprovalsSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import React, { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const getOrderAwaitingApprovalsParameter = (state as CustomAppState).xOrderAwaitingApprovalSearchFields
        ?.getOrderAwaitingApprovalsParameter;
    return {
        orderAwaitingApprovalsDataView: getOrderAwaitingApprovalsDataView(
            state as CustomAppState,
            getOrderAwaitingApprovalsParameter,
        ),
    };
};
const mapDispatchToProps = {
    updateAwaitingSearchFields,
};

type Props = WidgetProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface OrderAwaitingApprovalListPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: OrderAwaitingApprovalListPaginationStyles = {};

const styles = paginationStyles;

const OrderAwaitingApprovalListPagination = ({ updateAwaitingSearchFields, orderAwaitingApprovalsDataView }: Props) => {
    const changePage = (newPageIndex: number) => {
        updateAwaitingSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateAwaitingSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    if (!orderAwaitingApprovalsDataView.value) {
        return null;
    }

    const { pagination } = orderAwaitingApprovalsDataView;
    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={pagination.prevPageUri}
            nextPage={pagination.nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderAwaitingApprovalListPagination),
    definition: {
        group: "Order Approval List",
        displayName: "Other Acoounts Awaiting Approval Pagination",
        allowedContexts: ["OrderApprovalListPage"],
        isSystem: true,
    },
};

export default widgetModule;
